import React, { useState } from "react";
import AuthLayout from "../../components/authLayout/authLayout";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Static credentials
    const validEmail = "lrm@demo.com";
    const validPassword = "lrm_demo";

    if (email === validEmail && password === validPassword) {
      localStorage.setItem("isLoggedIn", "true");
      window.location.href = "/dashboard"; // or use navigate()
    } else {
      setError("Invalid email or password ❌");
    }
  };

  const renderItem = () => {
    return (
      <form onSubmit={handleSubmit}>
        <img src="/logo-new.png" className="logo" alt="logo dark" />
        <h2>Log in to your account</h2>
        <div className="form-group">
          <label>Email</label>
          <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div className="form-group">
          <label>Password</label>
          <div className="selected-input">
            <input type={showPassword ? "text" : "password"} className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} required />
            <button type="button" onClick={() => setShowPassword(!showPassword)} className={showPassword ? "ri-eye-line" : "ri-eye-off-line"}></button>
          </div>
        </div>
        {error && <p className="error-msg">{error}</p>}
        <button type="submit" className="btn btn-primary">
          Sign In
        </button>
      </form>
    );
  };

  return <AuthLayout renderItem={renderItem} />;
};

export default SignIn;
